<template>
  <div>
    <div id="menu-wrapper">
      <div id="menu">
        <div id="menu-top">
          <div id="menu-top-welcome">
            Welcome
          </div>
        </div>
        <ul>
          <li>
            <router-link
              ref="register_box_item"
              :class="{item_selected: itemActiveMap.bulk_creation_active}"
              class="item"
              to="/bulk-creation"
              @click.native="clickedItem('bulk_creation_active')"
            >
              <i
                class="fas fa-file-excel"
                style="margin-right: 0.5rem;"
              /> XLS Upload
            </router-link>
          </li>
          <li>
            <router-link
              ref="group_device_software"
              :class="{item_selected: itemActiveMap.group_device_software_active}"
              class="item"
              to="/group-device-software"
              @click.native="clickedItem('group_device_software_active')"
            >
              <i
                class="fas fa-layer-group"
                style="margin-right: 0.5rem;"
              /> Group Device Software
            </router-link>
          </li>
        </ul>
      </div>
      <div
        style="left: 0px;
                right: 0px;
                bottom: 0px;
                text-align: center;
                background: none;
                position: absolute;
                font-size: 10pt;"
      >
        <div>version {{ version }}</div>
      </div>
    </div>
  </div>
</template>

<script>

import { WEB_VERSION } from '../constants'

export default {
	data () {
		return {
			itemActiveMap: {
				bulk_creation_active: true,
        group_device_software_active: false
			},
			version: '',
			isAdmin: false,
			userType: 'Registered'

		}
	},
	mounted () {
		this.version = WEB_VERSION
	},
	methods: {
		// Not ideal, but it is at least generic without having to play with classes too much
		clickedItem: function (itemToActivate) {
			for (const property in this.itemActiveMap) {
				if (this.itemActiveMap.hasOwnProperty(property)) {
					this.itemActiveMap[property] = false
				}
			}

			this.itemActiveMap[itemToActivate] = true
		}
	}
}
</script>

<style lang="stylus" scoped>
#menu-wrapper
    padding-right: 5px;
    height: 100%;
    position: relative;

#menu
    height: 100%;
    background-color: white;
    color: #222;
    font-size: 14pt;
    -webkit-box-shadow: 2px 6px 12px #aaa;
    box-shadow: 2px 6px 12px #aaa;

    @media screen and (max-width: 600px) {
        font-size: 8pt;
    }

#menu > ul
    list-style-type: none;
    padding-left: 1rem;
    @media screen and (max-width: 600px) {
        padding-left: 0.5rem;
    }

#menu > ul > li
    margin-bottom: 2rem;
    text-align: left;

#menu-top
    background-color: #00a3d8;
    padding: 0.5rem;
    margin-bottom: 2rem;
    text-align: center;
    color: white;

#menu-top-welcome
    font-size: 24pt;
    font-style: italic;
    @media screen and (max-width: 600px) {
        font-size: 16pt;
    }

#menu-top-user
    font-size: 12pt;
    margin-top: 1rem;
    margin-bottom: 1rem;
    @media screen and (max-width: 600px) {
        font-size: 6pt;
    }

.item
    color: black;
    font-style: none;
    text-decoration: none;
    outline: none;

.item_selected
    color: #00a3d8;

</style>
